import {Component,  Fragment } from "react";
import MediaQuery from "react-responsive";
import Section from '../../common/Section';
import Button from '../../common/ui-components/input/Button';
import UIDropdown from '../../common/ui-components/input/UIDropdown/UIDropdown';
import UIModal from '../../common/ui-components/surface/UIModal';
import Plans from './plans'
import { makePlans, getBrandObject } from "../utils";
import { combineParamsString, formatNumber, getUtmString } from '../../../utils/index';
import { goToCart } from '../../../tracking/planPageTracking';
import styles from '../../../styles/modules/components/device.module.scss';
import { Hidden } from '@mui/material';
import CITIES_SLUG from '../../../city_constants';
import { goToCartClicked, readFaqLinkClick, subcategorySelected } from "../../../tracking/segment/planPage";
import { getPageURL } from "../../../utils/tracking";
import { getCartItemsSkuId } from "../../../utils/cart";

class SkuSelector extends Component<any,any>   {
  state:any = {
    brandObj: {},
    hasBrands: false,
    isBrandOpen: false,
    brandSelected: false,
    isChangeBrandModalOpen: false,
    changeBrandModalCallback: null,
    changeBrandModalServiceTitle: 'Repair',
    changeBrandModalCallbackItem: null,
    changeBrandModalCallbackEvent: null
  }
  loadPlanStates = () => {}

  closeChangeBrandModal = () => {
    this.setState({ isChangeBrandModalOpen: false });
  }

  onModalChangeBrandClick = () => {
    this.closeChangeBrandModal()
    this.setState({
      isBrandOpen: true
    });
  }

  closeBrandOpen = (status) => {
    this.setState({
      isBrandOpen: status
    });
    return true;
  }

  onModalContinueClick = () => {
    this.state.changeBrandModalCallback(
      this.state.changeBrandModalCallbackEvent, false, true
    )
    this.closeChangeBrandModal()
  }

  handleIncrementForBrand = (item, callback, event) => {
    this.setState({
      isChangeBrandModalOpen: true,
      changeBrandModalCallback: callback,
      changeBrandModalCallbackItem: item,
      changeBrandModalServiceTitle: item.title,
      changeBrandModalCallbackEvent: event
    });
  }

  setBrandObj = () => {
    let cart_items = this.props.cart.items.filter(i => i.category_type == this.props.device)
    if(!this.state.brandSelected){
      let brandObj = getBrandObject(cart_items)
      if(brandObj.value){
        this.setState({
          brandObj: brandObj,
          brandSelected: true
        })
      }
    }
  }
  planDict = (plans:any) => {
    let planDict = {}
    plans.forEach(plan => {
      if(planDict[plan.category] !== undefined) {
        planDict[plan.category].push(plan)
      } else {
        planDict[plan.category] = [plan]
      }
    });
    let orderedPlandict = Object.keys(planDict).reduce(
      (obj, key) => {
        obj[key] = planDict[key];
        return obj;
      }, {}
    );
    return orderedPlandict
  }

  handleBrandChange = (selectedBrand) => {
    this.setState({ brandObj: selectedBrand, brandSelected: true })
  }

  validateAndCheckout = () => {
    if (this.props.cart.items) {
      this.props.toggleRedirection()
      this.props.router.push(combineParamsString(`/cart/${this.props.cart.token_id}`, getUtmString()));
    }
    goToCart("AMCInsta", (this.props.device || '') ) // GTM TRIGGER - go To Cart
    goToCartClicked({...getPageURL(),'cart_amount':this.props.cart.amount, ...getCartItemsSkuId(this.props.cart.items)})
    return false
  }

  getBrandItems = (items, selectedBrand) => {
    let brand_items = {}
    items.forEach(item => {
      let brand = item.additional_details.brand
      if(brand){
        if(!brand_items[brand]){ brand_items[brand] = []; }
        brand_items[brand].push(item)
      }
    });
    return brand_items[selectedBrand] || [];
  }

  componentDidMount(){
    if (this.props.additional_details) {
      if(this.props.additional_details.is_mobile_tablet) {
        this.setState({
          custom_categories: this.props.additional_details.mobile_tablet_category_tabs,
          category_mapping: this.props.additional_details.category_mapping,
        })
      }
    }
  }

  groupByType = (plan_list:any) => {
    let grouped_list:any = []
    plan_list.forEach((plan: any) => {
      grouped_list.push(plan);
    })
    return grouped_list
  }

  getFilteredPlans = () => {
    let filtered_plans:any = []
    let plan_list:any = makePlans(this.props.cart.items, this.planDict(this.props.plans))
    let is_pine_labs_campaign = this.props.pineLabs
    if (this.state.custom_categories) {
      let categories = this.state.category_mapping ? this.state.category_mapping[this.props.selectedCategory] : [];
      categories && categories.forEach((category:any) => {
        plan_list[category].forEach((plan:any) => {
          // plan.title = `${plan.category_type} ${plan.title}`;
          filtered_plans.push(plan);
        });
      })
      return this.groupByType(filtered_plans);
    } else {
      filtered_plans = plan_list[this.props.selectedCategory];
      if (is_pine_labs_campaign){
        filtered_plans = filtered_plans.filter(plan => plan['product_type'] != "Comprehensive AMC");
      }
      return filtered_plans
    }
  }

  getCategorySelectorTitle = () => {
    if (this.props.isCH) {
      return 'Device'
    }
    if (this.props.additional_details?.is_mobile_tablet) {
      return 'Device'
    }
    return ((this.props.plans.length > 0 ? this.props.plans[0].category_type : ""))
  }

  render(){
    const device_name = this.props.slug_mapping?.device_name;
    const planBenefits = this.props.features.plan_selection ? this.props.features.plan_selection : []
    const brands = [...this.props.brands, "Other"]
    let total_plans = this.props.plans ? Object.keys(this.props.plans).length : 0;
    let hasPlans = total_plans > 0;
    let hasCategories = total_plans > 1;
    let filtered_plans = this.getFilteredPlans();
    if(this.props.plans.length > 0 && this.state.hasBrands){
      this.setBrandObj()
      let brand_items = this.getBrandItems(this.props.cart.items, this.state.brandObj.value)
      filtered_plans = makePlans(brand_items, this.planDict(this.props.plans))[this.props.selectedCategory];
      total_plans = filtered_plans.length
      if(!this.state.brandSelected){
        filtered_plans = filtered_plans.slice(0,3)
      }
    }
    const selection_features_list = Object.keys(planBenefits).map((benefit, index)=>{
      let list_title = planBenefits[benefit].filter(item => item.isHeading)[0]
      let list_items = planBenefits[benefit].filter(item => !item.isHeading)
      list_title = list_title ? list_title.text : (this.props.isCH ? 'Repair & Cleaning Services for Chimney & Hob': null)
      return <>
        {list_title && <h2 className={styles.benefits_heading} key={`benefit-heading-${index}`}>{list_title}</h2>}
        <ul key={`benefit-feature-${index}`} className={styles.selection__links}>
          {
            list_items.map((item, index) => <li className="device_selection__feature__list" key={`benefits-${index}`}>
              <h3>{item.text}</h3>
              </li>)
          }
        </ul>
      </>
    })
    let tabCategories = null
    if (this.state.custom_categories) {
      tabCategories = this.state.custom_categories.map((category_type, index) => {
          let categoryClassName = `selected__price_block`
          if(this.props.isCH){
            categoryClassName += '_chimney';
          }
          return (<Fragment key={`${index}-${category_type}`}>
            <label key={`li-${index}`} className={styles[categoryClassName]} htmlFor={category_type} >
              <input className="hidden-input" type="radio" name="plan-price" id={category_type} onChange={this.props.handleCategoryChange} checked={this.props.selectedCategory == category_type} />
              <div className={styles.selected__price_block__details} style={{ textAlign: "center", width: "100%" }} onClick={()=>{subcategorySelected({'sub_category':category_type,'category':this.props.category=='mobile-phones'?[' mobile-phones','tablets']:this.props.category})}}>
                  <span className={styles.price_block__discounted} style={{ fontSize: "1rem" }}>{category_type}</span>
              </div>
            </label>
          </Fragment>)
      })
    } else {
      tabCategories = this.props.tabCategories.map((category_type, index) => {
          let categoryClassName = `selected__price_block`
          if(this.props.isCH){
            categoryClassName += '_chimney';
          }
          return (<Fragment key={`${index}-${category_type}`}>
            <label key={`li-${index}`} className={styles[categoryClassName]} htmlFor={category_type} >
              <input className="hidden-input" type="radio" name="plan-price" id={category_type} onChange={this.props.handleCategoryChange} checked={this.props.selectedCategory == category_type} />
              <div onClick={()=>{subcategorySelected({'sub_category':category_type, 'category':this.props.category=='mobile-phones'?[' mobile-phones','tablets']:this.props.category})}} className={styles.selected__price_block__details} style={{ textAlign: "center", width: "100%" }}>
                  <span className={styles.price_block__discounted} style={{ fontSize: "1rem" }}>{category_type}</span>
              </div>
            </label>
          </Fragment>)
      })
    }
    const populat_localities_text = this.props.slug_mapping?.city && `We offer ${this.props.slug_mapping?.device_name} services in many areas in ${CITIES_SLUG[this.props.slug_mapping?.city].city}.`
    const sku_heading = this.props.features?.sku_heading ? this.props.features.sku_heading : `Plans and Services for your ${device_name ? device_name : this.getCategorySelectorTitle()}`
    return <>
        <Section className={`${styles.selection} ${styles.insta_repair}`} key={this.props.router.asPath}>
          <div className={`${styles.selection__container} container`} key={this.props.router.asPath}>
            <div className={`${styles.selection__row} row`}>
            <Hidden mdDown>
              <div className={`${styles.selection__left} col-12 col-sm-12 col-md-12 col-lg-6`}>
                <div className={styles.selection__features}>
                  {selection_features_list}
                  <div className={styles.selection__links}>
                    {this.props.slug_mapping?.is_generic?
                      <span>
                      Not sure if we service your area?&nbsp;
                      <a href="#" onClick={(e) => {
                        e.preventDefault();
                        document.querySelector("#cities")?.scrollIntoView({
                          behavior: 'smooth', block: 'nearest', })
                        }}> Check Covered Cities</a>
                    </span>:
                    <span>
                  {populat_localities_text}&nbsp;
                    <a href="#" onClick={(e) => {
                      e.preventDefault();
                      document.querySelector("#localities")?.scrollIntoView({
                        behavior: 'smooth', block: 'nearest', })
                      }}> Check Popular Localities </a>
                  </span>
                    }

                    <span>
                      Have questions on your mind?&nbsp;
                      <a href="#" onClick={(e) => {
                        e.preventDefault();
                        document.querySelector("#faqs")?.scrollIntoView({
                          behavior: 'smooth', block: 'nearest', })
                          readFaqLinkClick({})
                        }}> Read The FAQs</a>
                    </span>
                  </div>
                </div>
              </div>
              </Hidden>
              <div className={`${styles.selection__right} col-12 col-sm-12 col-md-12 col-lg-6`} id="plan-selection">
                <h2 className={styles.selection__right__title}>{sku_heading}</h2>
                {
                  this.state.hasBrands && <div className={styles.brand_selection}>
                    <UIDropdown
                      isOpen={this.state.isBrandOpen}
                      toggleState={this.closeBrandOpen}
                      search
                      onChange={this.handleBrandChange}
                      options={brands.map((brand) => {
                          return { key:brand, value:brand, text:brand }
                      })}
                      placeholder={`Select Brand`}
                      selected_option={this.state.brandObj.value ? this.state.brandObj : ''}
                    />
                    { !this.state.brandObj.value && <span><i>i</i> Select a brand to proceed further</span> }
                  </div>
                }
                <div className={`${styles.sku_list} ${(this.state.hasBrands && !this.state.brandSelected) ? styles.disabled : ''}`}>
                  {
                    hasCategories && <>
                      <h6 className={styles.sku_subtitle}>
                        Select the type of {
                          this.getCategorySelectorTitle()
                        }
                      </h6>
                      <div className={styles.selection__user__selected_price}>
                        {tabCategories}
                      </div>
                    </>
                  }
                  {
                    hasPlans && <>
                      <Plans
                        plans={filtered_plans} planStates={this.props.plans}
                        hasBrands={this.state.hasBrands} brand={this.state.brandObj.value}
                        loadPlanStates={this.loadPlanStates} setSelectedPlan={() => false}
                        handleIncrementForBrand={this.handleIncrementForBrand}
                        loadCart={()=>false} force closeModal={() => {}} device={device_name} 
                        sku_display_config={this.props.sku_display_config}/>
                      { !this.state.brandSelected && <div className={styles.more_text}> +{total_plans - 3} more</div> }
                    </>
                  }
                </div>
                {
                  (this.props.cart.type === 'insta-repair' || this.props.cart.type === 'amc') && <>
                    <MediaQuery maxDeviceWidth={992}> {/* mobile */}
                      <div className={`${styles.bottom_fixed} ${this.props.cart.items.length != 0 ? styles.open : ''}`.trim()} id="bottom-sticky-header">
                        <div className="row" style={{ display : "flex",alignItems : "center",justifyContent: "center",paddingLeft: "15px",paddingRight: "15px",paddingTop: "10px",paddingBottom: "10px"}}>
                          <div className="col-6"  style={{verticalAlign: "middle",textAlign: "left", fontSize: "bolder"}}>
                            <h6>Total: {formatNumber(this.props.cart.amount? this.props.cart.amount : 0)}</h6>
                            <span style={{fontSize: "12px"}}> {this.props.cart.quantity} {this.props.cart.quantity == 1 ? 'service selected' : 'services selected'}</span>
                          </div>
                          <div className="col-6">
                            <Button text="Go to Cart" variant="primary"  disabled={Object.keys(this.props.cart.items).length ? false : true} onClick={this.validateAndCheckout}/>
                          </div>
                        </div>
                      </div>
                    </MediaQuery>
                    <MediaQuery minDeviceWidth={992}> {/* desktop */}
                      <div className={styles.bottom_cta}>
                        <div className="row" style={{ display : "flex",alignItems : "center",justifyContent: "center"}}>
                          <div className={`col-7 col-sm-7 col-md-7 col-lg-7`}  style={{verticalAlign: "middle",textAlign: "left", fontSize: "bolder"}}>
                            <h6 >Total: {formatNumber(this.props.cart.amount? this.props.cart.amount : 0)}</h6>
                            <span> ( {this.props.cart.quantity} {this.props.cart.quantity == 1 ? 'service selected' : 'services selected'} )</span>
                          </div>

                          <div className="col-5">
                            <Button text="Go to Cart" variant="primary"  disabled={Object.keys(this.props.cart.items).length ? false : true} onClick={this.validateAndCheckout}/>
                          </div>
                        </div>
                      </div>
                    </MediaQuery>
                  </>
                }
              </div>
              <Hidden mdUp>
              <div className={`${styles.selection__left} col-12 col-sm-12 col-md-12 col-lg-6`}>
                <div className={styles.selection__features}>
                  {selection_features_list}
                  <div className={styles.selection__links}>
                    {this.props.slug_mapping?.is_generic?
                      <span>
                      Not sure if we service your area?&nbsp;
                      <a href="#" onClick={(e) => {
                        e.preventDefault();
                        document.querySelector("#cities")?.scrollIntoView({
                          behavior: 'smooth', block: 'nearest', })
                        }}> Check Covered Cities</a>
                    </span>:
                    <span>
                  {populat_localities_text}&nbsp;
                    <a href="#" onClick={(e) => {
                      e.preventDefault();
                      document.querySelector("#localities")?.scrollIntoView({
                        behavior: 'smooth', block: 'nearest', })
                      }}> Check Popular Localities </a>
                  </span>
                    }

                    <span>
                      Have questions on your mind?&nbsp;
                      <a href="#" onClick={(e) => {
                        e.preventDefault();
                        document.querySelector("#faqs")?.scrollIntoView({
                          behavior: 'smooth', block: 'nearest', })
                          readFaqLinkClick({})
                        }}> Read The FAQ's</a>
                    </span>
                  </div>
                </div>
              </div>
              </Hidden>
            </div>
          </div>
        </Section>
        <UIModal isPlainBG={true} isOpen={this.state.isChangeBrandModalOpen} onClick={this.closeChangeBrandModal} onOverlayClick={this.closeChangeBrandModal}>
          <div className={styles.change_brand_popup}>
            <p className={styles.info}>
              {this.state.brandObj.value} {this.props.selectedCategory}
            </p>
            <p className={styles.cta_text}>
              Would you like to continue adding {this.state.changeBrandModalServiceTitle} for the same brand ?
            </p>
            <div className={styles.cta}>
              <Button
                text='CHANGE BRAND'
                variant='green-inverse'
                onClick={this.onModalChangeBrandClick}
              />
              <Button
                text='CONTINUE'
                variant='green'
                onClick={this.onModalContinueClick}
              />
            </div>
          </div>
        </UIModal>
    </>;
  }
}
export default SkuSelector;
